import script from "./PopupCancelButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupCancelButton.vue?vue&type=script&setup=true&lang=ts"

import "./PopupCancelButton.vue?vue&type=style&index=0&id=574bd2a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-574bd2a1"]])

export default __exports__